import React, { useState } from "react";
import PropTypes from "prop-types";

import KeyboardInput from "../../../components/InputKeyboard";
import { t } from "../../../../helpers/translator";

const CasinoSearch = ({ onSubmit }) => {
    const [search, setSearch] = useState('');

    return <div className="search-container-column">
        <div className="search-box-v">
            <div className="single-form-item">
                <KeyboardInput type="text" placeholder={t("Search game name")} onChange={setSearch}/>
            </div>
            <button className="search-b" onClick={() => onSubmit(search)} />
        </div>
    </div>;
}

CasinoSearch.propTypes = {
    onSubmit: PropTypes.func
};

export default CasinoSearch;